import React, { PureComponent } from 'react'
import { preFix } from '@/constant'
import styles from './index.module.less'
import { handleStyle } from '@/utils/styleUtils'
import { BaseComponentItemPropsType } from '@/typings/types'
import { customJump, checkCanSkip } from '@/utils/business'

// interface IProps {
//   propsConfig: any
// }

interface ItemProps {
  text: string
  style?: React.CSSProperties
  targetUrl?: string
  customUrl?: string
  query?: string
}

interface IProps extends BaseComponentItemPropsType<ItemProps> {}

class Index extends PureComponent<IProps> {
  static config = {
    name: 'poizon-title',
  }
  componentDidMount() {}

  onClick = () => {
    const { propsConfig } = this.props
    if (propsConfig) {
      customJump({
        targetUrl: propsConfig?.targetUrl,
        customUrl: propsConfig?.customUrl,
        query: propsConfig?.query,
      })
    }
  }

  calcStyles = () => {
    const propsConfig = this.props.propsConfig || { text: '', style: {} }
    const { style, text } = propsConfig
    const canSkip = checkCanSkip({
      customUrl: propsConfig.customUrl,
      targetUrl: propsConfig.targetUrl,
    })

    const nextStyle = handleStyle(style, ['fontSize'])

    return canSkip
      ? {
          ...nextStyle,
          textDecoration: 'underline',
        }
      : nextStyle
  }

  render() {
    const propsConfig = this.props.propsConfig || { text: '', style: {} }
    const { style, text } = propsConfig

    return (
      <div className={preFix + Index.name}>
        <p onClick={this.onClick} className={styles.normal} style={this.calcStyles()}>
          {text}
        </p>
      </div>
    )
  }
}

export default Index
